import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { getRelativeDateTime } from '../../../../../utils/time'

// Utils
import { translation } from '../../../../../utils/helpers'

// Actions
import { getSparePartsReception, updateSparePartsReception } from '../../../../../actions/spareparts'
import { closeSlidePanel, openSlidePanel, isSlidePanelOpen } from '../../../../../actions/common'

// Elements
import TableContainer from '../../../../elements/tableContainer'
import TableExpand from '../../../../elements/tableExpand'
import TableHeader from '../../../../elements/tableHeader'
import TableRow from '../../../../elements/tableRow'
import Check from '../../../../elements/check'
import ArrowButton from '../../../../elements/arrowButton'
import Button from '../../../../elements/button'
import IconAccordion from '../../../../elements/iconAccordion'
import Grid from '../../../../elements/grid'
import Label from '../../../../elements/label'
import { SparePartModuleIcons } from '../../../../elements/icons'
import OverlayContent from '../../../../elements/overlayContent'
import BottomBar from '../../../../elements/bottomBar'
import Inline from '../../../../elements/inline'
import CheckButton from '../../../../elements/checkButton'

// Components
import ReceptionSlidePanel from '../../ReceptionSlidePanel'
import FilterSlidePanel from '../../filterSlidePanel'

import './receiving.scss'

class Receiving extends Component {
  constructor (props) {
    super(props)
    this.state = {
      spareParts: [],
      sparePartComments: [],
      // groups: [],
      selectedSpareParts: [],
      rowClicked: false,
      expand: {},
      slidePanelView: '',
      filterPanelView: '',

      isLoading: false
    }

    this.openSlidePanel = this.openSlidePanel.bind(this)
    this.resetSelected = this.resetSelected.bind(this)
    // this.groupData = this.groupData.bind(this)
    this.getStatusIcons = this.getStatusIcons.bind(this)
    this.renderGroup = this.renderGroup.bind(this)
  }

  componentDidMount () {
    this.setState({
      isLoading: true
    }, () => this.props.getSparePartsReception({ ...this.props.sparePartsFilter, OrderId: this.props.orderId }).then(() => {
      this.setState({
        isLoading: false
      })
    }))
  }

  componentDidUpdate () {
    if (!isEqual(this.props.spareParts, this.state.spareParts)) {
      this.setState({
        spareParts: this.props.spareParts
      })
    }
  }

  openSlidePanel (type, newState = {}) {
    this.setState({
      ...newState,
      slidePanelView: type
    }, () => this.props.openSlidePanel('sparePartsReception'))
  }

  resetSelected () {
    this.setState({
      selectedSpareParts: []
    })
  }

  getGroupedSpareParts () {
    const spareParts = this.state.spareParts.reduce((grouped, part) => {
      const supplierName = (part.Suppliers && part.Suppliers.length > 0) ? part.Suppliers[0].Name : ''

      if (!grouped[supplierName]) {
        grouped[supplierName] = [ part ]
      } else {
        grouped[supplierName] = [ ...grouped[supplierName], part ]
      }

      return grouped
    }, {})

    return spareParts
  }

  getStatusIcons (part) {
    let statusIcons = [ { icon: SparePartModuleIcons.Warning, noCircle: true } ]
    if (part.Handled === part.Count) {
      statusIcons = [ { icon: SparePartModuleIcons.OK, noCircle: true } ]
    }

    // Defective part
    if ((part.Status & 32) !== 0) {
      statusIcons.push({ icon: SparePartModuleIcons.Defective })
    }
    // Incorrect part
    if ((part.Status & 64) !== 0) {
      statusIcons.push({ icon: SparePartModuleIcons.Incorrect })
    }

    return statusIcons
  }

  getDeliveryTime (part) {
    let relativeDateTime = ''

    if (part.Suppliers.length > 0) {
      const supplier = part.Suppliers[0]
      relativeDateTime = getRelativeDateTime(supplier.DeliveryDate)
    }

    return (
      <Label>{relativeDateTime}</Label>
    )
  }

  getStatusInfo (part) {
    let statusIcons = this.getStatusIcons(part)

    const getStatusText = () => {
      switch (part.Status) {
        case 32:
          return 16453
        case 64:
          return 16454
        default:
          return null
      }
    }

    return (
      <Grid cols={['100px', 'auto']}>
        <IconAccordion icons={statusIcons} />
        <Label>{getStatusText()}</Label>
      </Grid>
    )
  }

  renderGroup (group, index) {
    const title = group[0]
    const items = group[1]
    const headerCols = '5fr 6fr 8fr'
    const cols = '1fr 2.5fr 3fr 2.5fr 2.5fr 3fr 3fr 2fr 32px'

    const hasOrderedStatus = (status) => {
      return (status & 8) === 8
    }

    const isChecked = (part, isAll = false, isRow = false) => {
      if (isAll) {
        const notHandledItems = items.filter(x => hasOrderedStatus(x.Status))
        let checked = notHandledItems.every(x => this.state.selectedSpareParts.some(selected => isEqual(selected, x)))
        checked = checked && notHandledItems.length > 0
        checked = checked && !this.state.rowClicked
        return checked
      }

      return this.state.selectedSpareParts.findIndex(selected => isEqual(selected, part)) > -1 && this.state.rowClicked === isRow
    }

    const onCheckAll = (e) => {
      const { name, checked } = e.target

      if (name === 'all') {
        let updatedSpareParts = [ ...this.state.selectedSpareParts ]
        if (this.state.rowClicked) updatedSpareParts = []

        // Remove all from current group
        updatedSpareParts = updatedSpareParts.filter(selected => (
          !(items.findIndex(part => isEqual(part, selected)) > -1)
        ))

        if (checked === true) {
          updatedSpareParts = [ ...updatedSpareParts, ...items.filter(x => hasOrderedStatus(x.Status)) ]
        }

        if (updatedSpareParts.length === 0) this.props.closeSlidePanel('sparePartsReception')
        this.setState({
          selectedSpareParts: updatedSpareParts,
          rowClicked: false
        })
      }
    }

    const renderRow = (row, index) => {
      const partNumber = row.SparePartNumberAlias || row.OriginalSparePartNumber

      const onCheckChange = (e) => {
        const { name, checked } = e.target

        if (name === 'sparePart') {
          let updatedSpareParts = [ ...this.state.selectedSpareParts ]
          if (this.state.rowClicked) updatedSpareParts = []

          if (checked === true) {
            updatedSpareParts = [ ...updatedSpareParts, row ]
          } else {
            updatedSpareParts = updatedSpareParts.filter(pt => !isEqual(pt, row))
          }

          if (updatedSpareParts.length === 0 || this.state.rowClicked) this.props.closeSlidePanel('sparePartsReception')
          this.setState({
            selectedSpareParts: updatedSpareParts,
            rowClicked: false
          })
        }
      }

      const onRowClick = (type) => {
        if (!type) {
          const hasOnlyOneStatus = (row.Status & (row.Status - 1)) === 0
          // if all has a status show list view
          type = (/* row.Handled !== row.Count || */ hasOnlyOneStatus || hasOrderedStatus) ? 'status' : 'listDetail'
        }

        this.openSlidePanel(type, {
          selectedSpareParts: [ row ],
          rowClicked: true
        })
      }

      const receiveSparePart = (e) => {
        e.stopPropagation()

        const sparePartsBody = {
          OrderId: this.props.orderId,
          SpareParts: [ row ],
          Status: 16, // Received
          Filter: this.props.sparePartsFilter
        }

        this.props.updateSparePartsReception(sparePartsBody)
      }

      const getQualityInfo = () => {
        let qualityInfo = ''
        switch (row.QualityType) {
          case 0:
            qualityInfo = translation(17850)
            break
          case 1:
            qualityInfo = translation(17851)
            break
          case 2:
            qualityInfo = translation(76)
            let subQualityInfo = ''
            switch (row.SubQualityType) {
              case 1:
                subQualityInfo = `, ${translation(17852)})`
                break
              case 2:
                subQualityInfo = `, ${translation(17853)})`
                break
              case 3:
                subQualityInfo = `, ${translation(17854)})`
                break
            }
            qualityInfo += subQualityInfo
            break
        }
        return (
          <span>{qualityInfo}</span>
        )
      }

      // const disabled = !hasOrderedStatus(row.Status)
      const isReceived = row.Status === 16
      return (
        <TableRow key={index} cols={cols} onClick={() => onRowClick()} selected={isChecked(row, false, true)}>
          <Check name='sparePart' value={row} checked={isChecked(row)} onChange={onCheckChange} /* disabled={disabled} */ simple />
          <span>{partNumber}</span>
          <span>{row.Description || ''}</span>
          <span>{`${row.Handled} ${translation(16436)} ${row.Count}`}</span>
          {this.getStatusInfo(row)}
          {this.getDeliveryTime(row)}
          {getQualityInfo()}
          {!isReceived && <Button onClick={receiveSparePart} style='link' size='m' labelText={translation(16452)} />}
          {row.Count > 1 ? <ArrowButton size='m' onClick={(e) => { e.stopPropagation(); onRowClick('listDetail') }} /> : ''}
        </TableRow>
      )
    }

    // const totalSpareParts = items.reduce((a, b) => a + b.Count, 0)
    // const totalHandledSpareParts = items.reduce((a, b) => a + b.Handled, 0)
    const totalStatus = items.reduce((status, part) => {
      status.Handled += part.Handled
      status.Count += part.Count

      // if (part.Pickup) {
      //   status.Pickup = true
      // }
      // if (part.RequirePaint) {
      //   status.RequirePaint = true
      // }
      status.Status |= part.Status

      return status
    }, { Handled: 0, Count: 0 })

    const statusIcons = this.getStatusIcons(totalStatus)
    const totalText = translation(16439).replace('[count]', totalStatus.Handled).replace('[total]', totalStatus.Count)
    const expand = this.state.expand[title] === true || typeof this.state.expand[title] === 'undefined'

    const onClick = (expand) => {
      this.setState({
        expand: {
          ...this.state.expand,
          [title]: expand
        }
      })
    }

    return (
      <TableContainer key={index} fullWidth>
        <TableExpand expand={expand} onClick={onClick}>
          <TableHeader cols={headerCols}>
            <span>{title}</span>
            <span>{totalText}</span>
            {!expand && <IconAccordion icons={statusIcons} />}
            {expand && <span />}
          </TableHeader>

          <TableRow header cols={cols}>
            <Check name='all' checked={isChecked(null, true)} onChange={onCheckAll} spacing={0} simple />
            <span>{translation(16440)}</span>
            <span>{translation(1021)}</span>
            <span>{translation(16441)}</span>
            <span>{translation(13052)}</span>
            <span />
            <span>{translation(17849)}</span>
            <div />
            <div />
          </TableRow>

          {items.map(renderRow)}
        </TableExpand>
      </TableContainer>
    )
  }

  renderActionHeader () {
    return (
      <div className='top renderActionHeader'>
        <span>{translation(16580)}</span>
      </div>
    )
  }

  renderFilterActions () {
    const onClick = (e) => {
      this.setState({
        filterPanelView: e.target.name
      }, () => this.props.openSlidePanel('sparePartsFilter'))
    }

    return (
      <Inline className='filter'>
        <div className='filter__title'>{translation('16659')}</div>
        <CheckButton name='supplier' onClick={onClick} checked={(this.props.sparePartsFilter.SelectedFilters & 2) === 2} labelText={translation('16657')} size='m' />
        <CheckButton name='status' onClick={onClick} checked={(this.props.sparePartsFilter.SelectedFilters & 1) === 1} labelText={translation('13052')} size='m' />
      </Inline>
    )
  }

  render () {
    const hasSelectedSpareParts = this.state.selectedSpareParts.length > 1

    const groupedSpareParts = Object.entries(this.getGroupedSpareParts())
    return (
      <div className='receiving'>
        <OverlayContent>
          {hasSelectedSpareParts && !this.props.isSlidePanelOpen('sparePartsReception') && (
            <BottomBar
              actionLabelText={translation(16448)}
              onActionClick={() => this.openSlidePanel('status')}
              cancelLabelText={translation(1155)}
              onCancelClick={this.resetSelected}
              center
            />
          )}

          <div className='content'>
            {this.renderActionHeader()}
            {this.renderFilterActions()}

            {this.state.isLoading && (
              <div className='animated-background'>
                <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
                <span className='sr-only'>{translation('13382')}...</span>
              </div>
            )}
            {!this.state.isLoading && groupedSpareParts.map(this.renderGroup)}
          </div>
        </OverlayContent>

        <ReceptionSlidePanel
          orderId={this.props.orderId}
          spareParts={this.state.selectedSpareParts}
          view={this.state.slidePanelView}
          onDone={this.resetSelected}
        />
        <FilterSlidePanel
          type='reception'
          orderId={this.props.orderId}
          view={this.state.filterPanelView}
          filter={this.props.sparePartsFilter}
        />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    spareParts: state.spareParts.sparePartsReception,
    sparePartsFilter: state.spareParts.sparePartsFilterReception,
    slidePanelsLength: state.common.slidePanels.length // Necessary for the isSlidePanelOpen check to function
  }
}

export default connect(mapStateToProps, {
  getSparePartsReception,
  updateSparePartsReception,
  closeSlidePanel,
  openSlidePanel,
  isSlidePanelOpen
})(Receiving)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/spareParts/tabs/receiving/index.js